/**
 * Created by andrey on 08.08.2025
 */

cc.RemoveSelf = function (isNeedCleanUp = true) {
    cc.ActionInstant.prototype.constructor.call(this);

    this._isNeedCleanUp = isNeedCleanUp;
};

cc.RemoveSelf.prototype = Object.assign(Object.create(cc.ActionInstant.prototype), {
    constructor: cc.RemoveSelf,

    update: function () {
        this.target.removeFromParent(this._isNeedCleanUp);
    }
});

cc.removeSelf = (isNeedCleanUp) => new cc.RemoveSelf(isNeedCleanUp);
